export class VisualizatorSettings {
  constructor() {}

  static copySettingsArray(settingsList) {
    let listCopy = [];
    for (let i = 0; i < settingsList.length; i++) {
      listCopy.push(settingsList[i].copy());
    }
    return listCopy;
  }

  copy() {
    return new VisualizatorSettings();
  }
}
